import React, { useEffect, useRef } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { useSelector, useDispatch } from "react-redux";
import Cookies from 'js-cookie';
import LoginPage from "./containers/LoginPage";
import Authenticated from "./containers/Authenticated";
import {Modal, Notification, Spinner} from 'player-components';
import DummyAudio from "./components/DummyAudio";
import {selectNotifications, resetNotifications, setClientConfig, selectClientConfig, selectUserInputtingText, setUserInputtingText, setParentVersion, setAppStarted, selectAppStarted, selectOfflineModalVisible, setOfflineModalVisible} from './features/ui/uiSlice';
import {setAuth, setSubscribedAsync, selectStatus, selectUser} from './features/auth/authSlice';
import { syncUserSetlistsWithS3Async } from './features/setlists/setlistsSlice';

import {syncHeight, } from './factories/ui';
import platform from 'platform';
import NotSupportedSplash from './components/NotSupportedSplash';
import OfflineVersioning from './containers/OfflineVersioning';
import ScreenRotationWarning from "./components/ScreenRotationWarning";
import ErrorModalContainer from "./containers/ErrorModal";
import MediaSession from './containers/MediaSession';
import PackageJSON from "../package.json";

import "./App.css";
import "./index.css";
import LoggingInModal from "./components/LoggingIn";
import NoSleepContainer from "./containers/NoSleep";
import OfflineModal from "./components/OfflineModal";

	// pgw 13-jul-2025 - attempt to fix setlist bug
// import { store, persistor } from './store'; // adjust path to match your setup

import { store } from './store'; // persistor not needed here
import debounce from 'lodash.debounce'; // optional but recommended


import { logToIndexedDB, getLogsFromIndexedDB, clearLogsFromIndexedDB } from './indexedLogger';

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from './debugLog';

// pgw 24-aug-2026 - for CG login
import { isCgTestingEnabled } from "./utils/cgTesting";
import { checkRemoteAppVersion } from "./utils/appVersionCheck";


let doprint = false;
// let doprint = true;





export const DEBUG_LOG_KEY = 'debugLogs';

export const logToLocalStorage = (message, payload = null) => {
	const logs = JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
	const timestamp = new Date().toISOString();

	const now = new Date();
	const ukTimeWithSeconds = now.toLocaleTimeString('en-GB', {
	  hour: '2-digit',
	  minute: '2-digit',
	  second: '2-digit',
	  timeZone: 'Europe/London',
	  hour12: false
	});

	let msg = `${ukTimeWithSeconds}`;


	if (payload) {
		msg = msg + ` m=${message} p=${payload}`
// 		logs.push({ message, payload });
		logs.push(msg);
	}
	else {

		msg = msg + ` m=${message}`
		logs.push(msg);
// 		logs.push(message);
	}
	// 	logs.push({ timestamp, message, payload });
	debugLog("message = ", message)
	localStorage.setItem(DEBUG_LOG_KEY, JSON.stringify(logs));
};


export const logToLocalStorageMP = (message, payload = null) => {
};


export const getLogsFromLocalStorage = () => {
  return JSON.parse(localStorage.getItem(DEBUG_LOG_KEY)) || [];
};

export const clearLogs = () => {
  localStorage.removeItem(DEBUG_LOG_KEY);
};


			
export const getAppState = () => {
	debugLog('getAppState 1');
	let state = store.getState();
	debugLog('getAppState 1');
	return state;
};




export function logAllSetlists(state) {

	debugLog('App:logAllSetlists 1')
	logToIndexedDB('App:logAllSetlists 1');

	try {

		debugLog('logAllSetlists state = ', state);


	  const setlistsObj = state.setlists;

		debugLog('logAllSetlists setlistsObj = ', setlistsObj);

	  const setlists = setlistsObj.setlists;

		debugLog('logAllSetlists setlists = ', setlists);


	  logToIndexedDB('App: Current setlists');

	  if (setlists && setlists.length) {

		  debugLog('App Current setlists, setlists.length = ', setlists.length);
		  logToIndexedDB('App Current setlists, setlists.length = ', setlists.length);

		  if (setlists[0]) {
			  debugLog('App Current setlists, setlists[0] = ', setlists[0]);
			  logToIndexedDB('App Current setlists, setlists[0] = ', setlists[0]);
		  }

		  setlists.forEach(sl => {
			debugLog('App sl.title = ', sl.title);
			logToIndexedDB('App sl.title = ', sl.title);
			sl.items.forEach(song => {
				debugLog('App song.mix = ', song.mix);
				logToIndexedDB('App song.mix = ', song.mix);
			});
		  });

	  }
	  else {
		  logToIndexedDB('App Current setlists, setlists.length undefined ' );
	  }
	}
	catch(e) {
  		logToIndexedDB('App logAllSetlists, e = ', e);
  		logToIndexedDB(e);
  		debugLog('App logAllSetlists, e = ', e);
	}
}



export function monkeyPatch() {


	try {
	  const originalSetItem = localStorage.setItem;
	  const originalGetItem = localStorage.getItem;
	  const originalRemoveItem = localStorage.removeItem;

	  localStorage.setItem = function (key, value) {

		if (key.includes('root')) {

			const outer = JSON.parse(value);
			debugLog('outer.setlist = ', outer.setlist);

			let sl2;


			if (outer.setlist) {
				sl2 = JSON.parse(outer.setlists);

				debugLog('sl2.setlists.length = ', sl2.setlists.length);
				logToLocalStorageMP('sl2.setlists.length = ', sl2.setlists.length)

				if (sl2.setlists) {

					debugLog('sl2.setlists[0].title = ', sl2.setlists[0].title);
					logToLocalStorageMP('sl2.setlists[0].title = ', sl2.setlists[0].title)

					if (sl2.setlists[0].length > 0) {
						debugLog('a sl2.setlists[0].items[0].url = ', sl2.setlists[0].items[0].url);
						debugLog('a sl2.setlists[0].items[0].artist = ', sl2.setlists[0].items[0].artist);

						logToLocalStorageMP('a sl2.setlists[0].items[0].url = ', sl2.setlists[0].items[0].url);
						logToLocalStorageMP('a sl2.setlists[0].items[0].artist = ', sl2.setlists[0].items[0].artist);

					}

					debugLog('sl2.setlists[0] = ', sl2.setlists[0]);
					if (sl2.setlists[0].items) {
						debugLog('b sl2.setlists[0].items.length = ', sl2.setlists[0].items.length);
						debugLog('b sl2.setlists[0].items[0].url = ', sl2.setlists[0].items[0].url);

						logToLocalStorageMP('b sl2.setlists[0].items.length = ', sl2.setlists[0].items.length);
						logToLocalStorageMP('b sl2.setlists[0].items[0].url = ', sl2.setlists[0].items[0].url);

					}
					else {
						debugLog('sl2.setlists[0].items false or undefined ');
					}
			
				}
				else {
					debugLog('sl2.setlists false or undefined ');
				}
			}
			else {
				debugLog('outer.setlist false or undefined ');
			}
		}

		return originalSetItem.apply(this, arguments);
	  };

	  localStorage.getItem = function (key) {
		if (key.includes('root')) {
			debugLog('getItem key = ', key);
		}
		const result = originalGetItem.apply(this, arguments);
		return result;
	  };

	  localStorage.removeItem = function (key) {
		debugLog(`🗑 [removeItem] ${key}`);
		return originalRemoveItem.apply(this, arguments);
	  };

	}
	catch(e) {
  		logToLocalStorageMP('App logAllSetlists, e = ', e);
  		logToLocalStorageMP(e);
  		debugLog('App logAllSetlists, e = ', e);
	}
}


// pgw 03-oct-2025
// put near the top of App.js or a utilities file
async function isReallyOnline(timeoutMs = 2500) {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: ctrl.signal,
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(t);
  }
}

const SONG_LIST_URL = 'https://sessionplayer.s3.amazonaws.com/song_list_choirplayer_new_format_with_embedded_lyrics_and_sheeturl.json';


(function () {
})();


// pgw 29-sep-2025

function useSafeNavigate() {
const navigate = useNavigate();
return React.useCallback((to, opts) => {
  try {
	if (typeof to !== 'string' && (typeof to !== 'object' || to == null)) {
	  console.warn('[safeNavigate] invalid target:', to);
	  return;
	}
	// Normalize string paths (HashRouter likes leading '/')
	if (typeof to === 'string' && to.length && to[0] !== '/') {
	  to = '/' + to;
	}
	navigate(to, opts);
  } catch (e) {
	console.error('[safeNavigate] navigation failed:', e, 'target:', to, 'opts:', opts);
  }
}, [navigate]);
}


function App({parentVersion, clientConfig}) {

	debugLog('clientConfig App started p1, clientConfig = ', clientConfig);

 
	window.logToLocalStorage = logToLocalStorage;
	window.logAllSetlists = logAllSetlists;
	window.getAppState = getAppState;


	window.logToIndexedDB = logToIndexedDB;
	window.getLogsFromIndexedDB = getLogsFromIndexedDB;
	window.clearLogsFromIndexedDB = clearLogsFromIndexedDB;


	debugLog('clientConfig App started p1, clientConfig = ', clientConfig);


	window.store = store;

	logToIndexedDB('logToIndexedDB App started p1, store = ' + store);
	debugLog('logToIndexedDB App started p1, store = ' , store);
	debugLog('logToIndexedDB App started p1, window.store = ' , window.store);

  const platformName = useRef(platform.name);

	// pgw 12-jul-2025 fix for blank page bug
	let notifications;

	try {
		notifications = useSelector(selectNotifications);
	}
	catch(e) {
		logToIndexedDB('App: in handleBeforeUnload p4, e = ', e)
	}


  // const notifications = useSelector(selectNotifications);

  	let clientConfiguration;
	try {
		clientConfiguration = useSelector(selectClientConfig);
	}
	catch(e) {
		debugLog('App: in handleBeforeUnload p5, e = ', e)
		logToIndexedDB('App: in handleBeforeUnload p5, e = ', e)
	}


  const authStatus = useSelector(selectStatus);
  const currentUser = useSelector(selectUser);
  const setlistsS3LoadedForUserRef = useRef(null);
  const userInputtingText = useSelector(selectUserInputtingText);

  const appStarted = useSelector(selectAppStarted);
  const offlineModalVisible = useSelector( selectOfflineModalVisible)
  const dispatch = useDispatch();

// pgw 29-sep-2025
//   const navigate = useNavigate();
const navigate = useSafeNavigate();
const location = useLocation();

useEffect(() => {
  checkRemoteAppVersion(`route-change:${location.pathname}${location.search || ""}`);
}, [location.pathname, location.search]);

useEffect(() => {
  const existingValue = window.localStorage.getItem("saveSetlists");

  if (existingValue !== "1") {
    if (doprint) console.log("[SETLISTS S3] enabling saveSetlists by default");

    window.localStorage.setItem("saveSetlists", "1");
  } else {
    if (doprint) console.log("[SETLISTS S3] saveSetlists already enabled");
  }
}, []);

useEffect(() => {
  const saveSetlistsEnabled = window.localStorage.getItem("saveSetlists") === "1";


  const userEmail = currentUser?.userEmail || currentUser?.userName || window.localStorage.getItem("UGC_USER_EMAIL") || "";

  if (!saveSetlistsEnabled) {
    return;
  }

  if (!currentUser || currentUser.guest || !userEmail) {
    return;
  }

  if (setlistsS3LoadedForUserRef.current === userEmail) {
    return;
  }

  setlistsS3LoadedForUserRef.current = userEmail;


  if (doprint) console.log("[SETLISTS S3] App startup syncing setlists with S3", {
    userEmail,
    userName: currentUser.userName,
  });

  dispatch(syncUserSetlistsWithS3Async());


}, [
  dispatch,
  currentUser?.guest,
  currentUser?.userEmail,
  currentUser?.userName,
]);

// pgw 03-oct-2025
useEffect(() => {


  debugLog('songlist useEffect start')

  let cancelled = false;

  async function seedSongList() {
    debugLog('songlist useEffect seedSongList cancelled = ', cancelled)
    if (cancelled) return;
    const online = await isReallyOnline(2500);
    debugLog('songlist useEffect seedSongList online = ', online)
    if (!online) return;

    try {
      // This warms your Workbox runtime cache via your SW route.
      debugLog('songlist useEffect seedSongList before fetch ')

	// pgw 17-oct-2025
// 	console.log('SONG_LIST_URL = ', SONG_LIST_URL)
// 	console.log('clientConfig.features.library.endpoint = ', clientConfig.features.library.endpoint)

      // await fetch(SONG_LIST_URL, { cache: 'reload', credentials: 'omit' });
      await fetch(clientConfig.features.library.endpoint, { cache: 'reload', credentials: 'omit' });

      debugLog('songlist useEffect seedSongList after fetch ')
    } catch (e) {
      // ignore — we only seed when possible
      debugLog('songlist useEffect seedSongList e = ', e)
    }
  }

  // run once after mount
  seedSongList();

  // OPTIONAL: retry a couple times in case Wi-Fi comes up just after launch
  const retries = [3000, 7000]; // ms
  retries.forEach(delay =>
    setTimeout(() => { if (!cancelled) seedSongList(); }, delay)
  );

  debugLog('songlist useEffect 1 end')


  return () => { cancelled = true; };
}, []);


  useEffect(() => {

	debugLog('clientConfig useEffect 1 start')

	if (clientConfig) {
		debugLog('clientConfig useEffect 1 p1 clientConfig defined')
	}
	else {
		debugLog('clientConfig useEffect 1 p2 clientConfig not defined')
	}


	logToIndexedDB('App: in useEffect for handleBeforeUnload p1');


    const handleBeforeUnload = (event) => {
      logToIndexedDB('App: in handleBeforeUnload Page is about to unload');

		try {
			// log the current setlists
			let state = store.getState();

			debugLog('App: store = ', store);
			debugLog('App: state = ', state);

			logToIndexedDB('App: in handleBeforeUnload p1 before calling logAllSetlists')

			logAllSetlists(state);
			logToIndexedDB('App: in handleBeforeUnload p2 after calling logAllSetlists')
		}
		catch(e) {
			debugLog('App: in handleBeforeUnload p1, e = ', e)
			logToIndexedDB('App: in handleBeforeUnload p1, e = ', e)
		}

		// Optional: trigger browser confirm dialog
		//       event.preventDefault();
		//       event.returnValue = ''; // Required for most modern browsers


    };

	logToIndexedDB('App: in useEffect before window.addEventListener handleBeforeUnload');
	window.addEventListener('beforeunload', handleBeforeUnload);
	logToIndexedDB('App: in useEffect after window.addEventListener handleBeforeUnload');

    // Cleanup on unmount
    return () => {
		logToIndexedDB('App: in useEffect before window.removeEventListener handleBeforeUnload');
		window.removeEventListener('beforeunload', handleBeforeUnload);
		logToIndexedDB('App: in useEffect after window.removeEventListener handleBeforeUnload');
    };
	debugLog('useEffect 1 end')

  }, []); // empty dependency array: run only once



  useEffect(()=>{

	debugLog('clientConfig useEffect 2 start')

		if (clientConfig) {
			debugLog('clientConfig useEffect 2 p1 clientConfig defined')
		}
		else {
			debugLog('clientConfig useEffect 2 p2 clientConfig not defined')
		}

      dispatch(setAppStarted(false));
      dispatch(setOfflineModalVisible(false));
      ReactGA.initialize(clientConfig.features.analytics.token);
      document.documentElement.style.setProperty('--theme-primary-color', clientConfig.theme.colours.primary);
      document.documentElement.style.setProperty('--theme-primary-alt-color', clientConfig.theme.colours.primaryAlt);
      window.addEventListener('resize', syncHeight);
      document.body.addEventListener('resize', syncHeight);
      syncHeight();
      dispatch(resetNotifications());
      ReactGA.send("pageview");

		// pgw 03-aug-2025
		if (clientConfig) {
			debugLog('clientConfig useEffect 2 p3 clientConfig defined, clientConfig = ', clientConfig)
      		dispatch(setClientConfig(clientConfig));
		}
		else {
			debugLog('clientConfiguseEffect 2 p4 clientConfig not defined, clientConfig = ', clientConfig)
      		dispatch(setClientConfig(clientConfig));
		}
      
		// 
      //dispatch(setClientConfig(clientConfig));

      dispatch(setUserInputtingText(false));
      dispatch(setParentVersion(parentVersion));
      setTimeout(()=> dispatch(setAppStarted(true)), 1000);
	debugLog('clientConfig useEffect 2 end')
  }, []);

  useEffect(()=> {
	debugLog('clientConfig useEffect 3 start')

	if (clientConfig) {
		debugLog('clientConfig useEffect 3 p1 clientConfig defined')
	}
	else {
		debugLog('clientConfig useEffect 3 p2 clientConfig not defined')
	}

    if (clientConfig) {


	  /*
      if (clientConfig.features.auth.mode === "domainCookie") {
        const session_id = Cookies.get(clientConfig.features.auth.domainCookie.cookieId);
        if (session_id) {
          // check endpoint to see if logged in AND subscription status
          dispatch(setSubscribedAsync(session_id));
        } else {
            // debugLog('Nobody is logged in , so setting to default guest')
            dispatch(setAuth(clientConfig.features.auth.domainCookie.loggedOutState));
        }      
      }
	  */
		
	/*
	  if (isCgTestingEnabled()) {
		const token = window.localStorage.getItem("AUTH_TOKEN");

		if (token) {
		  dispatch(setAuth({
			status: "fulfilled",
			errorMessage: null,
			credentials: null,
			user: {
			  ID: "choirgenius-user",
			  displayName: "ChoirGenius User",
			  subscribed: true,
			  guest: false,
			  choirGenius: true,
			},
		  }));
		} else {
		  dispatch(setAuth({
			status: "fulfilled",
			errorMessage: null,
			credentials: null,
			user: {
			  ID: "choirgenius-guest",
			  displayName: "Guest User",
			  subscribed: false,
			  guest: true,
			  choirGenius: true,
			},
		  }));
		}

		return;
	  }
	*/


	  if (isCgTestingEnabled()) {
		const token = window.localStorage.getItem("AUTH_TOKEN");

		dispatch(setAuth({
		  status: "fulfilled",
		  errorMessage: null,
		  credentials: null,
		  user: token
			? {
				ID: "choirgenius-user",
				displayName: "ChoirGenius User",
				subscribed: true,
				guest: false,
				choirGenius: true,
			  }
			: {
				ID: "choirgenius-guest",
				displayName: "Guest User",
				subscribed: false,
				guest: true,
				choirGenius: true,
			  },
		}));

		return;
	  }

	  if (clientConfig.features.auth.mode === "domainCookie") {
		const session_id = Cookies.get(clientConfig.features.auth.domainCookie.cookieId);
		if (session_id) {
		  dispatch(setSubscribedAsync(session_id));
		} else {
		  dispatch(setAuth(clientConfig.features.auth.domainCookie.loggedOutState));
		}      
	  }


    }
	debugLog('clientConfig useEffect 3 end')

  },[clientConfig])


  // pgw 08-oct-2025 - skip version check ('cos it does not work in Chrome on iPhone running iOS 26)
  const isValidApple = () => {
    const products = ['iPhone', 'iPad'];
    try {
      if (products.includes(platform.product) && platform.version  ) {
        if (Number(platform.version?.split('.')[0]) < 15) {
          return true;
          // return false;
        }
      } else if (platform.os?.family === 'OS X' && navigator.maxTouchPoints) { // is iPad
        if (Number(platform.version?.split('.')[0]) < 15) {
          return true;
          // return false;
        }
      }
    } catch (e) {

    }
    return true;
  }

	const renderApp = () => {


		// pgw 12-jul-2025 fix for blank page bug
		notifications = [];

		switch (authStatus) {
		  case 'pending':
			return <LoggingInModal loginLogo={`${process.env.PUBLIC_URL}${clientConfiguration.images.loginLogo}`}/>
		  case 'fulfilled':
		  case 'initial': {

			const browserDenied = clientConfiguration?.logic?.deniedBrowsers?.includes(platformName.current);

			/*
			console.log("pgw renderApp platformName.current =", platformName.current);
			console.log("pgw renderApp platform.product =", platform.product);
			console.log("pgw renderApp deniedBrowsers =", clientConfiguration?.logic?.deniedBrowsers);
			console.log("pgw renderApp browserDenied =", browserDenied);
			console.log("pgw renderApp isValidApple() =", isValidApple());
			*/

			if (isValidApple() || !browserDenied) {
			  return <Routes>

				{clientConfiguration.features.auth.mode === 'postSubmission' && (
				  <Route path="/" element={<LoginPage />} />
				)}

				{isCgTestingEnabled() && (
				  <Route path="/login" element={<LoginPage />} />
				)}

				<Route path="*" element={<Authenticated parentVersion={parentVersion || PackageJSON.version}/>} />


			  </Routes>
			} else {
			  alert('not supported');
			  return <NotSupportedSplash platform={platform.product} logoUrl={clientConfiguration.images.loginLogo}/>
			}
		  }

		  default:
			return <LoginPage />
		}
	}  

  return clientConfiguration ? <div className={`App ${clientConfiguration.theme.darkMode ? 'dark': ''}`}>
       { appStarted ? renderApp() : <Modal onClose={()=>{}} content={<p className="flex justify-center text-center"><Spinner /></p>} isOpen={true} />}
        {/* <DummyAudio /> */}
        {notifications.map(n => <Notification key={n.id} type={n.type} title={n.title} text={n.text} />)}
        <ScreenRotationWarning logoImageUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.loginLogo}`} userInputtingText={userInputtingText} />
        <OfflineVersioning />
        <ErrorModalContainer />
        <NoSleepContainer />
        <MediaSession />
        <OfflineModal 
            onClose={()=>{
                navigate('/setlists');
                dispatch(setOfflineModalVisible(false));
            }}
            isOpen={offlineModalVisible}
        />
    </div> : <div></div>
    
}

// --- pgw add: connectivity-change listener (no hooks at top-level)
// pgw 17-oct-2025
// Leave console.log() and debugLog() calls, as removing them caused a problem (possibly due to code being removed if nothing in try block)
(function(){
  function onConn(e){
    try {
      var d = (e && e.detail) || (window.__CONNECTIVITY_STATUS__ || {});
      if (d && d.suspect) {
        try { console.log('[connectivity-change] suspect VPN condition:', d); } catch(_){}
        try { debugLog('connectivity suspect VPN condition: ', d); } catch(_){}
      }
    } catch(_){}
  }
  if (typeof window !== 'undefined') {
    try { window.removeEventListener('connectivity-change', onConn); } catch(_){}
    try { window.addEventListener('connectivity-change', onConn); } catch(_){}
  }
})();
// --- end add ---


export default App;
